import React from 'react'
import styled from 'styled-components'

// These are the darker lines that go along with the full-hours
const Lines = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background-image: linear-gradient(#a4adaf .02em, transparent .07em);
  background-size: 99.70% 90px;
`
// These are the lines that go along with the half-hours. We show them with a distance of 45px from the top.
const LinesMiddle = styled.div`
  top: 45px;
  height: 100%;
  width: 100%;
  position: absolute;
  background-image: linear-gradient(#d4dee0 .02em, transparent .07em);
  background-size: 99.70% 90px;
`

export default function UILines () {
  // There is no need to create another node, just use a fragment to wrap the divs
  return (
    <>
      <Lines/>
      <LinesMiddle/>
    </>
  )
}